import React from 'react';
import { Tab, Tabs } from '@kambria/kambria-lego';
import KarmaHistory from './_karma';
import CreditHistory from './_credit';
import KatKyteHistory from './_katKyte';
import enums from 'helpers/const';

const HistoryTabs = {
  KARMA: 'karma',
  CREDITS: 'credits',
  KAT: 'kat',
  KYTE: 'kyte',
};

class History extends React.PureComponent {
  state = { selectedTab: HistoryTabs.KARMA };

  changeTab = (value) => {
    this.setState({ selectedTab: value });
  };

  renderTabContainer = () => {
    const { selectedTab } = this.state;
    const { KARMA, CREDITS, KAT, KYTE } = HistoryTabs;
    const { HISTORY_TYPE } = enums;
    switch (selectedTab) {
      case KARMA:
        return <KarmaHistory />;
      case CREDITS:
        return <CreditHistory />;
      case KAT:
        return <KatKyteHistory key={KAT} type={HISTORY_TYPE.KAT} />;
      case KYTE:
        return <KatKyteHistory key={KYTE} type={HISTORY_TYPE.KYTE} />;
      default:
        break;
    }
  };

  render() {
    const { selectedTab } = this.state;
    return (
      <React.Fragment>
        <h4>History</h4>
        <Tabs className="balance">
          {Object.keys(HistoryTabs).map((key) => {
            const value = HistoryTabs[key];
            return (
              <Tab
                className={selectedTab === value ? 'active' : null}
                key={key}
                tabId={value}
                label={value}
                handleChange={this.changeTab}
              />
            );
          })}
        </Tabs>
        {this.renderTabContainer()}
      </React.Fragment>
    );
  }
}

export default History;
